const markup = (text:string) => {
    return {__html: text }
};

export default markup;